import React from 'react';
import './BenefitCard.scss';

interface BenefitCardProps {
  title: string;
  description: string;
}

const BenefitCard: React.FC<BenefitCardProps> = ({ title, description }) => {
  return (
    <div className="benefits-card-grid-item">
      <p>
        <span className="strong">{title}</span>
        <br />
        <br />
        {description}
      </p>
    </div>
  );
};

export default BenefitCard;
